import React from "react";
import OpcionDefecto from "../../../../../Common/Components/OpcionDefecto";
import CheckDefecto from "../../../../../Common/Components/CheckDefecto";

const MarcaCompartida = ({ data, selectCheckBox, selectCombo }) => {
    const { GET_ATLAS_MARCA_COMPARTIDA } = data;
    const arrayAux = GET_ATLAS_MARCA_COMPARTIDA.filter(d => d.Checked);

    return (
        <div className="row top-separator-xxs">
            <div className="col-xs-12 top-separator-xxs">
                <label className="label-primary">{"Marcas Compartidas"}</label>
            </div>
            <div className="col-xs-12">
                <CheckDefecto
                    nombre={"Asociar Programa de Marcas Compartidas"}
                    check={data.AsociaMarcaCompartida}
                    referencia={"MARCOMP"}
                    selectCheckBox={(event) => selectCheckBox("AsociaMarcaCompartida", event.target.checked)}
                />
            </div>
            {data.AsociaMarcaCompartida && <div className="col-xs-12 left-separator-xs top-separator-xxs">
                {GET_ATLAS_MARCA_COMPARTIDA.map( ( item ) => {
                    const referencia = `GMC-${item.Id}`;

                    return (
                        <CheckDefecto
                            key={item.Id}
                            nombre={item.Descripcion}
                            check={item.Checked}
                            activo={item.Activo}
                            referencia={referencia}
                            selectCheckBox={() => {
                                if ( data.AsociaMarcaCompartida ) {
                                    selectCheckBox( "GET_ATLAS_MARCA_COMPARTIDA", item.Id );
                                }
                            }}
                        />
                    )
                } )}
            </div>}
            <div className="col-xs-12">
            {data.AsociaMarcaCompartida &&<OpcionDefecto
                    infoData={arrayAux}
                    referencia={"MarcaCompartidaDefaultId"}
                    valorCombo={data.MarcaCompartidaDefaultId}
                    valorChecked={data.MarcaCompartidaDefaultInterfaz}
                    selecciono={arrayAux.length}
                    selectCombo={(value) => selectCombo("MarcaCompartidaDefaultId", value)}
                    selectCheckBox={(value) => selectCheckBox("MarcaCompartidaDefaultInterfaz", value)}
                />}

                {(data.ERROR_PRODUCT["seleccionoMarcaCompartida"] == false && arrayAux.length<1)
                    && <label className="error">{"Debe seleccionar al menos una marca compartida."}</label>}
            </div>
        </div>
    );
}

export default MarcaCompartida;